import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import b2bApiClient from '@/shared/api/b2b-client'

export class AppApiService {
  constructor() {
    this.client = b2bApiClient.getClient()
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  async getCoins() {
    try {
      return await this.client.get(
        '/processing/coins',
        {},
        {
          headers: this._headers,
        }
      )
    } catch (error) {
      console.error('Error creating swap app:', error)
      throw error
    }
  }
}

export const appApiService = new AppApiService()
export default appApiService
